export default 'Mentions légales | Solution Éco France';
